<template>
  <div
    class="c-app"
    :class="{ 'c-dark-theme': $store.state.darkMode }"
  >
    <TheSidebar />
    <CWrapper>
      <TheHeader />
      <TheAside />
      <div class="c-body">
        <main class="c-main">
          <CContainer fluid>
            <transition name="fade">
              <router-view />
            </transition>
          </CContainer>
        </main>
        <TheFooter />
      </div>
    </CWrapper>
    <AiAgentPanel />
    <button
      v-if="!panelOpen"
      type="button"
      class="ai-launcher"
      title="Ask RingbaX AI (Ctrl+I)"
      aria-label="Ask RingbaX AI (Ctrl+I)"
      @click="togglePanel"
    >
      <span class="ai-launcher__glow" />
      <span class="ai-launcher__sparkle">✦</span>
    </button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import TheAside from 'Components/Layout/TheAside'
import TheSidebar from 'Components/Layout/TheSidebar'
import TheHeader from 'Components/Layout/TheHeader'
import TheFooter from 'Components/Layout/TheFooter'
import AiAgentPanel from '@/components/AiAgent/AiAgentPanel.vue'

export default {
  name: 'LayoutDefault',
  components: {
    TheAside,
    TheSidebar,
    TheHeader,
    TheFooter,
    AiAgentPanel
  },

  computed: {
    ...mapState('aiAgent', ['panelOpen'])
  },

  mounted() {
    window.addEventListener('keydown', this.onGlobalKey)
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.onGlobalKey)
  },

  methods: {
    ...mapActions('aiAgent', ['togglePanel']),

    onGlobalKey(event) {
      const target = event.target || document.activeElement
      const tag = target?.tagName
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || target?.isContentEditable) {
        return
      }

      const isModifier = event.ctrlKey || event.metaKey
      if (!event.repeat && isModifier && event.key && event.key.toLowerCase() === 'i') {
        event.preventDefault()
        this.togglePanel()
      }
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.ai-launcher {
  position: fixed;
  right: 22px;
  bottom: 26px;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 0;
  background: linear-gradient(135deg, #5b73e8 0%, #8b5cf6 100%);
  color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.4rem;
  box-shadow: 0 8px 24px rgba(91, 115, 232, 0.35), 0 4px 12px rgba(139, 92, 246, 0.25);
  z-index: 1040;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.ai-launcher:hover {
  transform: translateY(-2px) scale(1.04);
  box-shadow: 0 12px 32px rgba(91, 115, 232, 0.45), 0 6px 16px rgba(139, 92, 246, 0.3);
}

.ai-launcher__sparkle {
  position: relative;
  z-index: 1;
  animation: ai-sparkle 2.4s ease-in-out infinite;
}

.ai-launcher__glow {
  position: absolute;
  inset: -4px;
  border-radius: 50%;
  background: linear-gradient(135deg, #5b73e8 0%, #8b5cf6 100%);
  opacity: 0.4;
  filter: blur(10px);
  z-index: 0;
  animation: ai-launcher-pulse 2.4s ease-in-out infinite;
}

@keyframes ai-sparkle {
  0%, 100% { transform: rotate(0) scale(1); }
  50% { transform: rotate(180deg) scale(1.15); }
}

@keyframes ai-launcher-pulse {
  0%, 100% { opacity: 0.3; transform: scale(1); }
  50% { opacity: 0.55; transform: scale(1.1); }
}
</style>
